import React, { useCallback } from 'react';

import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import { Button } from '../../../../../components/button/Button';
import { useStyles } from './styles';
import { SectionProps } from './types';

// Use a named function declaration instead of FC with arrow function
export function ViewSection({ button, children, title }: SectionProps): React.ReactElement {
  const styles = useStyles();

  const renderButton = useCallback(() => {
    if (button) {
      const { title: btnLabel, ...rest } = button;

      return (
        <Button {...rest} variant="text" size="small" color="primary" className={styles.actionButton}>
          {btnLabel}
        </Button>
      );
    }

    return <></>;
  }, [button, styles.actionButton]);

  return (
    <>
      <Divider className={styles.divider} />

      <div className={styles.root}>
        <Typography>
          <b>{title}</b>
        </Typography>

        {renderButton()}
      </div>

      <div>{children}</div>
    </>
  );
}
